var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniqDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "design-tools_svgrepo.com"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50.9181 47.9277H44.3106V6.06007C44.3106 5.20798 43.6202 4.51755 42.7681 4.51755H7.54256C6.69046 4.51755 6.00003 5.20798 6.00003 6.06007V57.3385C6.00003 58.1906 6.69046 58.8811 7.54256 58.8811H24.0729V63.9399C24.0729 64.7918 24.7633 65.4824 25.6154 65.4824H50.9179C51.77 65.4824 52.4605 64.7918 52.4605 63.9399V49.4702C52.4607 48.6183 51.77 47.9277 50.9181 47.9277ZM41.2255 7.6026V15.3703H9.08508V7.6026H41.2255ZM24.0729 49.4702V55.796H9.08508V18.4554H41.2255V47.9279H25.6156C24.7635 47.9277 24.0729 48.6183 24.0729 49.4702ZM49.3756 62.3974H27.1579V51.0127H49.3754L49.3756 62.3974Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.1147 13.9877C15.4637 13.9877 16.561 12.89 16.561 11.541C16.561 10.1916 15.4635 9.09418 14.1147 9.09418C12.7662 9.09418 11.6689 10.1918 11.6689 11.541C11.6689 12.89 12.7662 13.9877 14.1147 13.9877ZM14.1147 10.9026C14.4673 10.9026 14.754 11.1891 14.754 11.541C14.754 11.8929 14.4671 12.1792 14.1147 12.1792C13.7626 12.1792 13.4759 11.8929 13.4759 11.541C13.4759 11.1889 13.7626 10.9026 14.1147 10.9026Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M31.9416 59.1521C33.2908 59.1521 34.388 58.0545 34.388 56.7053C34.388 55.3559 33.2906 54.2582 31.9416 54.2582C30.5926 54.2582 29.4949 55.3561 29.4949 56.7053C29.4951 58.0547 30.5926 59.1521 31.9416 59.1521ZM31.9416 56.0673C32.2937 56.0673 32.58 56.3536 32.58 56.7055C32.58 57.0572 32.2935 57.3433 31.9416 57.3433C31.5897 57.3433 31.303 57.057 31.303 56.7055C31.3032 56.3534 31.5895 56.0673 31.9416 56.0673Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M62.4573 4.65701H54.5326C53.6805 4.65701 52.9901 5.34745 52.9901 6.19954V45.1571C52.9901 45.3963 53.0456 45.6326 53.1527 45.8465L57.1148 53.7768C57.376 54.2996 57.9101 54.6299 58.4946 54.6299C59.0789 54.6299 59.6133 54.2998 59.8745 53.777L63.8373 45.8467C63.9445 45.6326 64 45.3965 64 45.1571V6.19954C63.9998 5.34745 63.3093 4.65701 62.4573 4.65701ZM58.4946 16.6461C59.7286 16.6461 60.7496 15.7266 60.9149 14.537V43.6146H56.0753V14.5409C56.2423 15.7286 57.262 16.6461 58.4946 16.6461ZM57.8558 14.1991C57.8558 13.8472 58.1425 13.5609 58.4944 13.5609C58.8467 13.5609 59.1332 13.8472 59.1332 14.1991C59.1332 14.551 58.8467 14.8373 58.4944 14.8373C58.1425 14.8373 57.8558 14.551 57.8558 14.1991ZM60.9147 7.74206V13.8614C60.7494 12.6718 59.7284 11.7522 58.4944 11.7522C57.2618 11.7522 56.2421 12.6697 56.0749 13.8572V7.74206H60.9147ZM58.4948 49.6362L57.0276 46.6997H59.9623L58.4948 49.6362Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniqDesign);
export default __webpack_public_path__ + "static/media/uniqDesign.b4a30010ef886fb4e514cade09cba22d.svg";
export { ForwardRef as ReactComponent };